export default __webpack_public_path__ + "static/fall24-e972585a258930a9ed19747f7ee0ca83.webp";